const services = {
    baseUrl: 'https://quickserk-back.herokuapp.com/',
    //baseUrl: 'http://localhost:4000/',
    clienteBase: 'cliente',
    clienteTraerPorCedula: 'traerPorCedula',
    clienteTraerPorPlaca: 'traerPorPlaca',
    refTraerTodos: 'traerTodos',
    refElementosValorBase: 'refElementosValor',
    refElementosValorTraerTodos: 'traerTodos',
    establecimientoBase: 'establecimiento',
    establecimientoTraerPorDocumentoUsuario: 'traerPorDocumentoUsuario',
    ordenServicioBase: 'ordenServicio',
    ordenServicioCrear: 'crearOrdenServicio',
    ordenServicioConsultarActivasSucursal: 'consultarOrdenesActivasSucursal',
    ordenServicioActualizarEstado: 'actualizarEstadoOrdenServicio',
    refEstadoOrdenBase: 'refEstadoOrden',
    refEstadoOrdenTraerPorLlave: 'traerPorllave',
    refPerfilBase: 'refPerfil',
    refServicioBase: 'refServicio',
    vehiculoBase: 'vehiculo',
    vehiculoTraerPorInicioDePlaca: 'traerPorInicioDePlaca',
    loginBase: 'login',
    loginIniciarSesion: 'iniciarSesion',
    loginGenerarPassword: 'generarPassword',
    loginValidarEstados: 'validarEstados',
    dashboardBase: 'dashboard',
    dashboardTarjetaCantidades: 'tarjetaCantidades'
}

export default services;